import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, testid }) => (
  <p
    data-testid={testid}
    className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#8C713A] mb-6 flex items-center gap-3"
  >
    <span className="inline-block h-px w-8 bg-[#8C713A]/70" />
    {children}
  </p>
);
